import _routes from './routes';

const routes = _routes;

export default routes;



// WEBPACK FOOTER //
// ./containers/Group/Homework/PaperBased/index.js